"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genDisplayedOptions = exports.genOtherValueObject = exports.getMarkingCommand = void 0;
var formatTextToCamelCase_1 = require("../../../utils/formatTextToCamelCase");
var toArray_1 = require("../../../utils/toArray");
var getMarkingCommand = function (_a) {
    var option = _a.option, isSelected = _a.isSelected;
    if (isSelected) {
        return option.isCorrect ? 'markCorrect' : 'markWrong';
    }
    else { //not selected
        if (option.isCorrect)
            return "revealCorrect";
    }
};
exports.getMarkingCommand = getMarkingCommand;
var genOtherValueObject = function (text) {
    var value_desc = (0, formatTextToCamelCase_1.formatTextToCamelCase)(text);
    return {
        value: "other",
        display_desc: text,
        value_desc: value_desc,
        display: "Other",
    };
};
exports.genOtherValueObject = genOtherValueObject;
var genDisplayedOptions = function (_a) {
    var injectOtherOption = _a.injectOtherOption, options = _a.options, valueProp = _a.valueProp, saveValueAsString = _a.saveValueAsString;
    /*
    if options has the other object already
    then do none of this inject business
    */
    if (options.find(function (op) { return op.value === "other"; }) ||
        !injectOtherOption)
        return {
            typicalOptions: options
        };
    var OtherValInValueProp = (0, toArray_1.toArray)(valueProp).find(function (v) {
        return saveValueAsString ?
            options.every(function (op) { return op.value !== v; })
            : (v === null || v === void 0 ? void 0 : v.value) === 'other';
    });
    var injectedOtherOption = saveValueAsString ?
        { value: "other", display: "Other", display_desc: (OtherValInValueProp || '') }
        :
            OtherValInValueProp || { value: "other", display: "Other", display_desc: '' };
    return { typicalOptions: options, injectedOtherOption: injectedOtherOption };
};
exports.genDisplayedOptions = genDisplayedOptions;
